import * as themeActions from "./theme.action";

export const themeFeatureKey = "themeInfo";

const initialState = {
    loading: false,
    errorMsg: "",
    themeList: [],
    themeListCount: 0
};

export const reducer = (state = initialState, { payload, type }) => {
    switch (type) {
        case themeActions.CREATE_THEME_REQUEST:
            return {
                ...state,
                loading: true
            }
            
        case themeActions.CREATE_THEME_SUCCESS:
            console.log('payload.data', payload.data)
            let createArr = state.themeList;
            createArr.unshift(payload.data);
            console.log('payload.data', payload.data)
            return {
                ...state,
                loading: false,
                themeList: createArr
            }

        case themeActions.CREATE_THEME_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case themeActions.UPDATE_THEME_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.UPDATE_THEME_SUCCESS:
            let findIndex = state.themeList.findIndex(o => o._id === payload.data._id);
            state.themeList.splice(findIndex, 1, payload.data);
            console.log('payload.data', payload.data, "state.themeList", state.themeList)
            return {
                ...state,
                loading: false
            }

        case themeActions.UPDATE_THEME_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case themeActions.DELETE_THEME_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.DELETE_THEME_SUCCESS:
            const removeArr = state.themeList.filter(o => o._id !== payload);
            return {
                ...state,
                loading: false,
                themeList: removeArr
            }

        case themeActions.DELETE_THEME_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case themeActions.LIST_THEME_REQUEST:
            return {
                ...state,
                loading: true
            }

        case themeActions.LIST_THEME_SUCCESS:
            console.log('payload', payload)
            return {
                ...state,
                loading: false,
                themeList: payload.data,
                themeListCount: payload.total
            }

        case themeActions.LIST_THEME_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        default: return state;
    }
};